// PrivateRoute.js
import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { GetOnboardingStatus } from 'components/logic/paymentgateway/GetOnboardingStatus';
import { Backdrop, CircularProgress } from '@mui/material';
import { checkForUpdates } from 'utils/versionCheck';

import FeatureBaseProvider from "components/feature-base/featureBase";

const PrivateRoute = () => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const verifySession = async () => {
      try {
        await GetOnboardingStatus(navigate);
      } catch (error) {
        console.error('Session check failed:', error);
      } finally {
        setChecking(false);
      }
    };
    verifySession();
  }, [navigate]);

  useEffect(() => {
    // Initial check after app loads
    const initialDelay = setTimeout(() => {
      console.log("Checking for updates...");
      checkForUpdates(); // force first check
    }, 10000);

    // Recheck every 15 minutes
    const intervalId = setInterval(() => {
      checkForUpdates();
    }, 15 * 60 * 1000);

    // Recheck every 60 minutes
    // const intervalSessionID = setInterval(() => {
    //   GetOnboardingStatus(navigate); // Now we can use navigate here
    // }, 60 * 60 * 1000);

    // Check again when tab becomes visible
    const onVisible = () => {
      if (!document.hidden) {
        checkForUpdates();
        GetOnboardingStatus(navigate);
      }
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      clearTimeout(initialDelay);
      clearInterval(intervalId);
      //clearInterval(intervalSessionID);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [navigate]);

  if (checking) {
    return (<Backdrop
      sx={{ color: "#fff", zIndex: 10000000 }}
      open={checking}
    >
      <CircularProgress color="inherit" />
    </Backdrop>) // Or a proper spinner component
  }

  return <FeatureBaseProvider><Outlet /></FeatureBaseProvider>;
};

export default PrivateRoute;
